import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";
import Home from "../Pages/Home";
import Administration from "../Pages/Administration";
// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";
import ChangePasswordFormNew from "../Pages/Authentication/ChangePasswordFormNew";
import ChangePasswordUnblocked from "../Pages/Authentication/ChangePasswordUnblocked";

// Import Utility Pages
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

// tables Pages

import DoubleAuthentication from "../Pages/Authentication/DoubleAuthentication";
import ReinisializePassword from "../Pages/Authentication/ReinisializePassword";
import ChangePasswordForm from "../Pages/Authentication/ChangePasswordForm";

import ListUsers from "../Pages/Administration/ListUsers/List";
import ListRoles from "../Pages/Administration/RoleAdministration/ListRoles";
import ListCleanroom from "../Pages/Administration/CleanroomAdministration/ListCleanroom";
import CreateNewUser from "../Pages/Administration/ListUsers/CreateUser";
import UpdateUser from "../Pages/Administration/ListUsers/UpdateUser";
import ListGroup from "../Pages/Administration/GroupAdministration/List";
import CreateNewGroup from "../Pages/Administration/GroupAdministration/CreateGroup";
import UpdateGroup from "../Pages/Administration/GroupAdministration/UpdateGroup";
import ErrorBoundary from "../ErrorBoundary";
import AccessProtectedRoute from "./AccessProtectedRoute";
import ReRoute from "../Pages/Authentication/RerouteOkta";
const idGroup = localStorage.getItem("currentOrg"); 


const authProtectedRoutes = [
  //home
  { path: "/home", component: <Home/> },
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },
  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // Tables pages
  { path: "/users-management", component: 
  <AccessProtectedRoute idGroup={idGroup} requiredRoles={['admin', 'superAdmin']}>
    <ListUsers />
  </AccessProtectedRoute> },
  { path: "/roles-management", component: 
  <AccessProtectedRoute idGroup={idGroup} requiredRoles={['admin', 'superAdmin']}>
    <ListRoles />
  </AccessProtectedRoute> },
  { path: "/cleanroom-management", component: 
  <AccessProtectedRoute idGroup={idGroup} requiredRoles={['admin', 'superAdmin']}>
    <ListCleanroom />
  </AccessProtectedRoute> },
  { path: "/create-user", component: <CreateNewUser/> },
  { path: "/update-user/:userId", component:
    <AccessProtectedRoute idGroup={idGroup} requiredRoles={['admin', 'superAdmin']}>
     <UpdateUser/>
     </AccessProtectedRoute> },
  { path: "/groups-management", component: 
  <AccessProtectedRoute idGroup={idGroup} requiredRoles={['admin', 'superAdmin']}>
    <ListGroup />
  </AccessProtectedRoute> },
  { path: "/create-group", component: <CreateNewGroup/> },
  
  { path: "/update-group/:groupId", component: 
  <AccessProtectedRoute idGroup={idGroup} requiredRoles={['admin', 'superAdmin']}>
  <UpdateGroup/> 
  </AccessProtectedRoute>},
  // eslint-disable-next-line react/display-name
  {path: "/",exact: true, component: <Navigate to="/home" /> },
];

const publicRoutes = [
  
  // Authentication Page
  { path: "/not-found", component: <ErrorBoundary /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/:language" ,component:<Login />},
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/change-password-new", component: <ChangePasswordFormNew/> },
  { path: "/change-password-unblocked", component: <ChangePasswordUnblocked/> },
  { path: "/register", component: <Register /> },
  { path: "/MFA", component: <DoubleAuthentication /> },
  { path: "/forgetPass/:username/:urlId/:language", component: <ReinisializePassword/> },
  { path: "/change-password", component: <ChangePasswordForm/> },
  { path: "/okta", component: <ReRoute/> },

 

  // Utility Pages
  { path: "/pages-404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },

];

export { authProtectedRoutes, publicRoutes };
